import { render, staticRenderFns } from "./lead_settings.vue?vue&type=template&id=6a817b36&"
import script from "./lead_settings.vue?vue&type=script&lang=js&"
export * from "./lead_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports